import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PROPERTY_TYPES } from '../../../constants';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';
import { FacilityFeatures } from './OverviewSections/FacilityFeatures';
import { PropertyOverview } from './OverviewSections/PropertyOverview';
import { SiteCertificationInformation } from './OverviewSections/SiteCertificationInformation';

import './PropertyDetailOverview.css';

const components = {
  facilityFeatures: {
    component: FacilityFeatures,
    condition: ({ property: { additionalDetails: { about = {} } = {} } = {}, viewer = {} }) => {
      return (
        (about.description || about.description2 || about.description3)
          && (!viewer.buildingSettings.overviewSectionsToShow
            || viewer.buildingSettings.overviewSectionsToShow.includes('Description'))
      );
    },
  },
  propertyOverview: {
    component: PropertyOverview,
    condition: ({ viewer = {} }) =>
      !viewer.buildingSettings.overviewSectionsToShow
      || viewer.buildingSettings.overviewSectionsToShow.includes('Overview'),
  },
  siteCertInfo: {
    component: SiteCertificationInformation,
    condition: ({
      property: { additionalDetails: { about = {} } = {} } = {},
      viewer = {},
      type,
    }) => {
      return ((!viewer.buildingSettings.overviewSectionsToShow
        || viewer.buildingSettings.overviewSectionsToShow.includes('Overview'))
        && (type === PROPERTY_TYPES.SITES)
        && (about.certifiedSiteStatus !== null && about.certifiedSiteStatus === 1));
    },
  },
};

const defaultComponentDisplayOrder = [
  'facilityFeatures',
  'propertyOverview',
  'siteCertInfo',
];

export function PropertyDetailOverviewComponent(props) {
  const componentDisplayOrder = props.viewer.componentDisplayOrder
    ? props.viewer.componentDisplayOrder.overviewKeys
    : defaultComponentDisplayOrder;

  const overviewSections = componentDisplayOrder.map(key => {
    const Component = components[key].component;
    const condition = components[key].condition(props);
    return (
      <ConditionalWrapper key={key} condition={condition}>
        <Component {...props} />
      </ConditionalWrapper>
    );
  });

  return (
    <div>
      {overviewSections}
    </div>
  );
}

// ToDo: Create a building proptype and import
PropertyDetailOverviewComponent.propTypes = {
  viewer: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    viewer: state.viewer,
  }),
)(PropertyDetailOverviewComponent);



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailOverview/PropertyDetailOverview.js